import { Navigate, useParams } from 'react-router-dom'
import { ROUTES } from '@/lib/paths'

/**
 * Forwards the original site's `/project/:slug` URLs to `/projects/:slug`,
 * keeping the slug intact so inbound links land on the right case study.
 */
export const LegacyProjectRedirect = () => {
  const { slug } = useParams<{ slug: string }>()
  return <Navigate to={slug ? ROUTES.project(slug) : ROUTES.projects} replace />
}
